module.exports = __webpack_public_path__ + "static/img/j1.4ee72991.png";